export default __webpack_public_path__ + "static/media/profile-photo-500.4f767868.png";